import React from 'react'
import _ from 'lodash'

export const SectionsList = ({ sections, kbSections, setState, ignoredSections }) => {
  const getSubSectionIds = (parentId, parentSectionIds, groupedSections) => {
    const subSections = []
    groupedSections[parentId].forEach((section) => {
      if (parentSectionIds.includes(section.id)) {
        subSections.push(getSubSectionIds(section.id, parentSectionIds, groupedSections))
      }
      subSections.push(section.id)
    })

    return [...new Set(subSections.flat())]
  }

  const updateIgnoredSections = (changedSections, checkbox_state) => {
    const updatedKBState = kbSections.map((section) => {
      if (changedSections.includes(section.id)) {
        return { ...section, ignored: checkbox_state }
      } else {
        return section
      }
    })
    setState({ type: 'SET_KB_SECTIONS', payload: updatedKBState })
  }

  const handleCheckboxChange = (event) => {
    const checkbox_state = event.target.checked
    const changed_section_id = parseInt(event.target.id)
    const groupedSections = _.groupBy(kbSections, 'parent_id')
    const parentSectionIds = Object.keys(groupedSections).map((key) => Number(key))

    let subSectionIds = []
    if (parentSectionIds.includes(changed_section_id)) {
      subSectionIds = getSubSectionIds(changed_section_id, parentSectionIds, groupedSections)
    }

    const changedSections = [...subSectionIds, changed_section_id]
    updateIgnoredSections(changedSections, checkbox_state)

    let ignoredSectionState = []
    if (checkbox_state) {
      ignoredSectionState = [...ignoredSections, ...changedSections]
    } else {
      ignoredSectionState = ignoredSections.filter((sectionId) => !changedSections.includes(sectionId))
    }

    setState({ type: 'SET_IGNORED_SECTIONS', payload: [...new Set(ignoredSectionState)] })
  }

  return (
    <ul className='sections-list'>
      {sections.map((section) => {
        const children = _.filter(kbSections, { parent_id: section.id })
        const hasChildren = children.length > 0
        return (
          <li key={section.id}>
            <label>
              <input id={section.id} type='checkbox' onChange={handleCheckboxChange} checked={section.ignored} />{' '}
              {section.name}
            </label>
            {hasChildren && (
              <SectionsList
                sections={children}
                kbSections={kbSections}
                setState={setState}
                ignoredSections={ignoredSections}
              />
            )}
          </li>
        )
      })}
    </ul>
  )
}
